import { createActionsHook } from 'react-sweet-state';

import {
  createDataHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { RiskSchema } from '../models/Risk';

const actionConfig = { resourcePath: '/risks' };

export const risksActions = createRestActions<RiskSchema>(actionConfig);

export const RisksStore = createRestStore<RiskSchema>({
  name: 'risks-store',
  actions: risksActions,
  actionConfig,
  containerDisplayName: 'risks-container',
  onInitAction: null,
});

export const useRisksData = createDataHook(RisksStore);
export const useRisksIsLoading = createLoadingHook(RisksStore);
export const useRisksActions = createActionsHook(RisksStore);
export const didRisksMutationFail = createMutationFailedCheck(actionConfig.resourcePath);